"use client"
import { getCookie, setCookie } from "./cookies"
import { canUseDOM } from "./dom"

export function determineABTestVariation(
  experimentName: string,
  variants: string[],
  weights: number[],
  defaultVariant: string,
): string {
  // Check if the variant is stored in localStorage
  if (!canUseDOM()) {
    return defaultVariant
  }

  const storedVariant = getCookie(experimentName)

  if (storedVariant) {
    return storedVariant
  }

  const totalWeight = weights.reduce((acc, weight) => acc + weight, 0)
  const randomValue = Math.random() * totalWeight

  let accumulatedWeight = 0
  for (let i = 0; i < variants.length; i++) {
    accumulatedWeight += weights[i]

    if (randomValue <= accumulatedWeight) {
      const variantName = variants[i]

      // Store the selected variant in localStorage
      setCookie(experimentName, variantName, 30)
      return variantName
    }
  }
  // Fallback if something goes wrong (shouldn't happen in a correctly configured setup)
  return defaultVariant
}
